interface URLComponents {
    pathName: string;
    queryString: string;
    hashString: string;
}

export function extractURLComponents(url: string): URLComponents | undefined {
    if (!url) {
        return undefined;
    }

    // Extract params out of the route
    let pathName = url;
    let queryString = '';
    let hashString = '';

    const hashIndex = pathName.indexOf('#');
    if (hashIndex !== -1) {
        hashString = pathName.substring(hashIndex);
        pathName = pathName.substring(0, hashIndex);
    }

    const queryIndex = url.indexOf('?');
    if (queryIndex !== -1) {
        queryString = pathName.substring(queryIndex);
        pathName = pathName.substring(0, queryIndex);
    }

    if (pathName !== '/' && pathName.startsWith('/')) {
        // Routes don't include a leading forward slash, but the path from express does,
        // we must remove it to properly match the path to the routes array.
        pathName = pathName.substring(1);
    }

    return {
        pathName,
        queryString,
        hashString,
    };
}

const ROUTE_TAG_MAP: Record<string, string> = {
    appxListingDetail: 'listingDetail',
    appxSearchKeywordResults: 'search',
    appxSavedListings: 'favorites',
};

const KNOWN_ROUTES = new Set([
    'learn',
    'collections',
    'try',
    'consulting',
    'error',
    'offer-request',
    'login',
    'search',
]);

const PRESERVE_SUBPATH = new Set(['explore']);

export function getRouteTag(path: string): string {
    if (!path) {
        return 'home';
    }
    const cleaned = path.replace(/^\//, '').replace(/^jp\//, '').split('?')[0];
    if (!cleaned) {
        return 'home';
    }
    const first = cleaned.split('/')[0];
    // Legacy routes get renamed (e.g. appxListingDetail → listingDetail)
    if (ROUTE_TAG_MAP[first]) {
        return ROUTE_TAG_MAP[first];
    }
    // Routes with bounded subpaths keep granularity (e.g. explore/agentforce)
    if (PRESERVE_SUBPATH.has(first)) {
        return cleaned;
    }
    // Known routes collapse to first segment, stripping slugs/IDs (e.g. learn/some-article → learn)
    if (KNOWN_ROUTES.has(first)) {
        return first;
    }
    // Unknown paths fall to 'other' to prevent unbounded tag cardinality
    return 'other';
}

export function buildUrl(baseUrl: string, params?: Record<string, any>) {
    let url = baseUrl;

    let hasFirstParam = url.includes('?');

    if (params) {
        Object.entries(params).forEach(([key, value]) => {
            if (hasFirstParam) {
                url += `&`;
            } else {
                hasFirstParam = true;
                url += `?`;
            }

            url += `${key}=${encodeURIComponent(String(value))}`;
        });
    }

    return url;
}
